// extracted by mini-css-extract-plugin
module.exports = {"button":"nav-button_button__UiuEp","active":"nav-button_active__oZbC3"};